/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_8_IntroInputs */

const en_privacy_section_8_intro = /** @type {(inputs: Privacy_Section_8_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For any privacy-related inquiries or to exercise your data protection rights, please contact us:`)
};

const lv_privacy_section_8_intro = /** @type {(inputs: Privacy_Section_8_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja Jums ir jautājumi par privātumu vai vēlaties izmantot savas datu aizsardzības tiesības, lūdzu, sazinieties ar mums:`)
};

/**
* | output |
* | --- |
* | "For any privacy-related inquiries or to exercise your data protection rights, please contact us:" |
*
* @param {Privacy_Section_8_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_8_intro = /** @type {((inputs?: Privacy_Section_8_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_8_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_8_intro(inputs)
	return en_privacy_section_8_intro(inputs)
});